class VerdictSummaryReportController {
    constructor($routeParams, $browser, $window, $location, $uibModal, ngProgressFactory, UserDetails, UserDetailsApi, toastr, ReportUtilityServiceApi, ReportServiceApi, SettingsService) {
        // Init component with $onInit
        this.$onInit = () => {
            this.init();
        };
        this.init = () => {
            this.state = {
                linkFromName: true,
                userDetails: null,
                colour: false,
                reportRequest: {
                    UserId: 0,
                    SimId: 0,
                    TestSuiteId: 0
                },
                gridOptions: {},
                DateFormats: {},
                activeTesters: [],
                showFilters: true,
                selectedSim: { Id: 0, Name: 'Unknown' },
                selectedSuite: { Id: 0, Name: 'Unknown' },
                selectedTest: null,
                hideNav: _.startsWith(this.location.path(), '/Reports')
            };
            this.data = {
                testerSimSuites: [],
                sims: [],
                suites: [],
                responseData: undefined
            };
            // @ts-ignore: Report clashes with dom.lib.d.ts Report
            this.verdictSummaryReport = {
                Id: 0,
                Name: '',
                Description: 'Verdict Summary Report',
                Route: '',
                Component: '',
                Icon: '',
                IsDeleted: false,
                LastAmended: null,
                LastAmendedBy: 0,
                ReportOrder: 0,
                IsExternal: false,
                Filetype: '',
                IdPId: ''
            };
            this.traceProgress = this.ngProgressFactory.createInstance();
            // this.toggleWidth = toggleWidth;
            // this.exportCsv = exportCsv;
            // this.selectSim = selectSim;
            // this.selectSuite = selectSuite;
            // Simulator | Test Suite | Test Case | #Pass | #Fail | %pass / %fail
            this.columnDefs = [
                { headerName: 'Simulator', field: 'SimName', width: 120, minWidth: 130, sort: 'asc' },
                { headerName: 'Test Suite', field: 'TestSuiteName', width: 120, minWidth: 135, sort: 'asc' },
                { headerName: 'Test Case', field: 'TestCaseName', minWidth: 135, cellRenderer: this.caseCellRenderer, sort: 'asc' },
                { headerName: 'Tests', field: 'TotalTests', width: 120, minWidth: 100 },
                { headerName: 'Pass', field: 'TotalPassed', width: 120, minWidth: 110, cellRenderer: this.passRenderer },
                { headerName: 'Fail', field: 'TotalFailed', width: 120, minWidth: 110, cellRenderer: this.failRenderer },
                { headerName: 'Suspended', field: 'TotalSuspended', width: 120, minWidth: 110, cellRenderer: this.suspendedRenderer },
                { headerName: 'Pass %', field: 'PercentagePassed', width: 120, minWidth: 110, cellRenderer: this.percentagePassVerdictRenderer },
                { headerName: 'Fail %', field: 'PercentageFailed', width: 120, minWidth: 110, cellRenderer: this.percentageFailVerdictRenderer },
                { headerName: 'Suspended %', field: 'PercentageSuspended', width: 120, minWidth: 110, cellRenderer: this.percentageSuspendedVerdictRenderer }
            ];
            this.gridOptions = {
                defaultColDef: {
                    resizable: true,
                    sortable: true,
                    filter: true
                },
                columnDefs: this.columnDefs,
                onModelUpdated: this.onModelUpdated,
                rowSelection: 'single',
                suppressMovableColumns: true, // Added because of ag-grid bug see https://github.com/ceolter/ag-grid/issues/965#issuecomment-225857509
                // Filtering
                isExternalFilterPresent: this.isExternalFilterPresent,
                doesExternalFilterPass: this.doesExternalFilterPass,
                angularCompileRows: true
            };
            this.SettingsService.getSettings().then((response) => {
                let appSettings = response.data;
                this.state.DateFormats = {
                    DateTimeFormat: appSettings.DateTimeFormat,
                    DateFormat: appSettings.DateFormat,
                    TimeFormat: appSettings.TimeFormat
                };
            }).then(() => {
                return this.getUserDetails();
            }).then(() => {
                this.ReportServiceApi.getReportByName('VerdictSummaryReport').then((response) => {
                    if (Object.keys(response.data).length > 0) {
                        this.verdictSummaryReport = response.data;
                    }
                    else {
                        this.toastr.warning('Report descriptions not found');
                    }
                });
            });
        };
        this.getUserDetails = () => {
            return this.UserDetails.get().then((data) => {
                this.state.userDetails = data; // setup our user details
                // if (this.state.userDetails.IsSupport) {
                //     this.hide = false;
                // }
                this.getVerdictSummaryReport();
            }, () => {
                this.toastr.error('Please make sure that you are logged in to OTS UTP!');
                this.window.location.href = this.browser.baseHref() + 'account/login';
                return;
            });
        };
        this.percentageFailVerdictRenderer = (row) => {
            return this.verdictRenderer(row.data.PercentageFailed, 'text-danger');
        };
        this.percentageSuspendedVerdictRenderer = (row) => {
            return this.verdictRenderer(row.data.PercentageSuspended, 'text-muted');
        };
        this.percentagePassVerdictRenderer = (row) => {
            return this.verdictRenderer(row.data.PercentagePassed, 'text-success');
        };
        this.passRenderer = (row) => {
            let functionCall = 'ng-click="vm.summaryDetailsPassed(data)">';
            return this.verdictRenderer(this.link(row.data.TotalPassed, functionCall), 'text-success');
        };
        this.failRenderer = (row) => {
            let functionCall = 'ng-click="vm.summaryDetailsFailed(data)">';
            return this.verdictRenderer(this.link(row.data.TotalFailed, functionCall), 'text-danger');
        };
        this.suspendedRenderer = (row) => {
            let functionCall = 'ng-click="vm.summaryDetailsSuspended(data)">';
            return this.verdictRenderer(this.link(row.data.TotalSuspended, functionCall), 'text-muted');
        };
        this.link = (total, functionCall) => {
            if (total < 1)
                return total;
            let link = ['<span',
                'ng-if="!vm.state.linkFromName">',
                total,
                '</span><a ng-href=""',
                'class="space-top pointer"',
                'title="View Summary Details"',
                'ng-if="vm.state.linkFromName"',
                functionCall,
                total,
                ' (details)',
                '</a>'
            ].join(' ');
            return link;
        };
        this.caseCellRenderer = (row) => {
            return this.createNonLinkCell(row.data.TruncatedTestCaseName, row.data.TestCaseName);
        };
        this.createNonLinkCell = (data, tooltip) => {
            let cell = [
                '<span title="',
                tooltip,
                '">',
                data,
                '</span>'
            ].join(' ');
            return cell;
        };
        this.summaryDetailsPassed = (row) => {
            this.summaryDetails(row, 1, 0);
        };
        this.summaryDetailsFailed = (row) => {
            this.summaryDetails(row, 0, 0);
        };
        this.summaryDetailsSuspended = (row) => {
            this.summaryDetails(row, 0, 1);
        };
        this.summaryDetails = (row, passed, suspended) => {
            let selectedItems = {
                selectedSim: { Id: row.SimId, Name: row.SimName },
                selectedSuite: { Id: row.TestSuiteId, Name: row.TestSuiteName },
                selectedTest: { Id: row.TestId, Name: row.TestCaseName },
                selectedPassed: passed,
                selectedSuspended: suspended
            };
            this.openDetails(selectedItems);
        };
        this.openDetails = (selectedItems) => {
            let modalInstance = this.uibModal.open({
                animation: true,
                size: 'xl',
                backdrop: 'static',
                keyboard: false,
                component: 'verdictSummaryDetails',
                resolve: {
                    user: this.state.userDetails,
                    selectedItems: selectedItems
                }
            });
        };
        this.autoSizeAll = () => {
            let allColumnIds = [];
            if (this.columnDefs === undefined || this.columnDefs === null) {
                this.columnDefs = this.gridOptions.columnDefs;
            }
            this.columnDefs.forEach((columnDef) => {
                allColumnIds.push(columnDef.field);
            });
            this.gridOptions.columnApi.autoSizeColumns(allColumnIds);
        };
        this.onModelUpdated = () => {
            let model = this.gridOptions.api.getModel();
            let processedRows = model.getRowCount();
            this.rowCount = processedRows.toLocaleString();
            this.autoSizeAll();
        };
        this.isExternalFilterPresent = () => {
            return this.state.selectedSim.Id > 0 ||
                this.state.selectedSuite.Id > 0;
        };
        this.doesExternalFilterPass = (node) => {
            // If no sim or test suite have been selected to filter on, don't filter out
            if (this.state.selectedSim.Id === 0 && this.state.selectedSuite.Id === 0) {
                return true;
            }
            // Matches selected sim but no test suite selected gives results for all
            // test suites on the sim
            if (node.data.SimId === this.state.selectedSim.Id && this.state.selectedSuite.Id === 0) {
                return true;
            }
            // Sim and Suite filter
            if (node.data.SimId === this.state.selectedSim.Id && node.data.TestSuiteId === this.state.selectedSuite.Id) {
                return true;
            }
            else {
                return false;
            }
        };
        this.getVerdictSummaryReport = () => {
            // NOTE: We get all of the data and then filter it on the client side
            this.traceProgress.start();
            let req = {
                UserId: 0,
                SimId: 0,
                TestSuiteId: 0
            };
            this.state.reportRequest = req;
            this.ReportServiceApi.getVerdictSummaryReport(req).then((response) => {
                this.traceProgress.complete();
                let data = response.data;
                this.data.responseData = response.data;
                this.gridOptions.api.setRowData(data.TestResults);
                this.rowData = data;
                this.data.testerSimSuites = data.TesterSimSuites;
                this.data.sims = this.ReportService.sims(this.data.testerSimSuites);
                this.state.selectedSim = this.data.sims[0];
                this.data.suites = this.ReportService.simSuites(this.data.testerSimSuites, this.state.selectedSim.Id);
                this.state.selectedSuite = this.data.suites[0];
                this.gridOptions.api.onFilterChanged();
            }, () => {
                this.traceProgress.complete();
            });
        };
        this.selectSim = (sim) => {
            if (this.data.sims === undefined || this.data.sims[0] === null) {
                // something is wrong with the data, we cant select back out.
                return;
            }
            // Initialise to first object in array and overwrite if object is defined
            this.state.selectedSim = this.data.sims[0];
            if (sim !== undefined || sim != null && Object.prototype.toString.call(sim) === '[object Object]') {
                this.state.selectedSim = sim;
            }
            this.data.suites = this.ReportService.simSuites(this.data.testerSimSuites, this.state.selectedSim.Id);
            this.state.selectedSuite = this.data.suites[0];
            this.gridOptions.api.onFilterChanged();
        };
        this.selectSuite = (suite) => {
            if (angular.isUndefined(suite)) {
                suite = { Id: 0, Name: 'All Suites' };
            }
            this.state.selectedSuite = suite;
            this.gridOptions.api.onFilterChanged();
        };
        this.exportCsv = () => {
            let title = [this.verdictSummaryReport.Description + '.csv'].join('');
            let reportName = this.ReportService.addDateToTitle(title);
            let params = {
                allColumns: false,
                fileName: reportName
            };
            this.gridOptions.api.exportDataAsCsv(params);
        };
        this.ngProgressFactory = ngProgressFactory;
        this.ReportServiceApi = ReportServiceApi;
        this.ReportService = ReportUtilityServiceApi;
        this.uibModal = $uibModal;
        this.location = $location;
        this.moment = moment;
        this.routeParams = $routeParams;
        this.SettingsService = SettingsService;
        this.UserDetailsApi = UserDetailsApi;
        this.UserDetails = UserDetails;
        this.toastr = toastr;
        this.browser = $browser;
        this.window = $window;
    }
    verdictRenderer(rowData, classToAdd) {
        let verdict = ['<span',
            'class="',
            classToAdd,
            '">',
            rowData,
            '</span>'
        ].join(' ');
        return verdict;
    }
}
// Component Declaration
angular.module('app').component('verdictSummaryReport', {
    templateUrl: 'Scripts/App/partials/Reports/Verdict-Summary-Report.tpl.html',
    bindings: {},
    controllerAs: 'vm',
    controller: VerdictSummaryReportController
});
